<template>
    <div>
        <reg-base-header-sec></reg-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <b-form @submit.stop.prevent="onSubmit" @reset="onReset">
                    <div class="row">
                        <div class="col-md-6">
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Подрегистар</label>
                                <select v-model="areaLevel1" class="form-control full-width" @change="keyV($event)">
                                    <option label="Све" value="-1">Све</option>
                                    <option v-for="option in searchFilter.areas" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Област</label>
                                <select v-model="areaLevel2" class="form-control full-width" @change="keyV1($event)">
                                    <option label="Све" value="-1">Све</option>
                                    <template v-if="areaLevel_2_options">
                                        <option v-for="option in areaLevel_2_options" v-bind:key="option.k"
                                            :value="option.k">
                                            {{ option.l }}
                                        </option>
                                    </template>
                                </select>
                            </b-form-group>
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Група</label>
                                <select v-model="areaLevel3" class="form-control full-width" @change="keyV2($event)">
                                    <option label="Све" value="-1">Све</option>
                                    <template v-if="areaLevel_3_options">
                                        <option v-for="option in areaLevel_3_options" v-bind:key="option.k"
                                            :value="option.k">
                                            {{ option.l }}
                                        </option>
                                    </template>
                                </select>
                            </b-form-group>


                            <b-form-group v-if="areaLevel_4_options.length > 0" class="form-group-sm">
                                <label class="form-label">Подгрупа</label>
                                <select v-model="areaLevel4" class="form-control full-width">
                                    <option label="Све" value="-1">Све</option>
                                    <template v-if="areaLevel_4_options">
                                        <option v-for="(option, index) in areaLevel_4_options" v-bind:key="index"
                                            :value="option.k">
                                            {{ option.l }}
                                        </option>
                                    </template>
                                </select>
                            </b-form-group>


                            <b-form-group v-if="areaLevel_5_options.length > 0" class="form-group-sm">
                                <label class="form-label">Подобласт/назив прописа</label>
                                <select v-model="areaLevel5" class="form-control full-width" @change="keyV3($event)">
                                    <option label="Све" value="-1">Све</option>
                                    <template v-if="areaLevel_5_options">
                                        <option v-for="(option, index) in areaLevel_5_options" v-bind:key="index"
                                            :value="option.url">
                                            {{ option.name }}
                                        </option>
                                    </template>
                                </select>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <!-- <b-form-group class="form-group-sm">
                                <label class="form-label">Врста документа</label>
                                <b-form-select v-model="form.docTypeIds" multiple class="form-control full-width"
                                               :select-size="7">
                                    <option label="Све" value="-1">Све</option>
                                    <option v-for="option in docTypes" v-bind:key="option.k" :value="option.k">
                                        {{option.l}}
                                    </option>
                                </b-form-select>
                            </b-form-group> -->

                            <b-form-group class="form-group-sm register">
                                <label class="form-label">Врста документа</label>
                                <multiselect v-model="form.docTypeIds" :options="docTypes" :multiple="true"
                                    placeholder="Све" track-by="k" label="l" :show-labels="false"></multiselect>
                            </b-form-group>


                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <label for="titleQuery" class="form-label">Речи садржане у наслову</label>
                        <div class="input-group ">
                            <input id="titleQuery" v-model="form.titleQuery" type="text" class="form-control full-width">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" v-model="form.titleMustOccur" class="mr-2" id="titleMustOccur">
                                    <label class="in-btn-form-label" for="titleMustOccur">
                                        Све ове речи
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <label for="bodyQuery" class="form-label">Речи садржане у тексту</label>
                        <div class="input-group ">
                            <input id="bodyQuery" v-model="form.bodyQuery" type="text" class="form-control full-width">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" v-model="form.bodyMustOccur" class="mr-2" id="bodyMustOccur">
                                    <label class="in-btn-form-label" for="bodyMustOccur">
                                        Све ове речи
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spacer20"></div>
                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="resultLimit" class="form-label mr-2">Величина резултата</label>
                                <select id="resultLimit" v-model="form.resultLimit" class="form-control">
                                    <option v-for="option in resultLimitOptions" v-bind:key="option" :value="option">
                                        {{ option }}
                                    </option>

                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">
                            <b-button v-if="searchResult !== null && searchResult.resultSize > 0" type="button"
                                @click="exportWord" class="btn btn-word-export text-uppercase mr-3">
                                <span class="mr-2">Експорт резултата претраге у WORD</span> <i class="icon-file-word-o"></i>
                            </b-button>
                            <b-button type="submit" class="btn btn-base-submit text-uppercase mr-3">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="reset" class="btn btn-base-reset text-uppercase">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </b-button>
                        </div>
                    </div>
                </b-form>
            </div>

            <result-counter v-if="searchResult !== null" :count="searchResult.resultSize"
                :limit="searchResult.limit"></result-counter>

            <div v-if="searchResult" class="base-box base-box__table-sec">
                <b-table class="table-bootstrap-vue" striped bordered :items="values" :fields="fields"
                     :sort-desc.sync="sortDesc" responsive="sm">
                    <template v-slot:cell(title)="data">
                        <!-- <a
                                :href="baseApiUrl + 'viewAct/' + data.item.uuid"
                                target="_blank"> {{ data.item.title }}</a> -->

                        <router-link v-if="data.item.uuid !== null && data.item.uuid !== ''"
                            :to="{ path: 'viewAct/' + data.item.uuid }" target="_blank">
                            <span class="text">{{ data.item.title }}</span>
                        </router-link>
                        <router-link v-else :to="'viewPdf/' + data.item.id" target="_blank">
                            {{ data.item.title }} </router-link>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { store } from "@/store";
import RegBaseHeaderSec from '@/base_pages/reg/RegBaseHeaderSec.vue';
// import {SortedTable, SortLink} from "vue-sorted-table";
import ResultCounter from '@/partials/ResultCounter.vue';




export default {
    name: "RegSearchPage",
    data() {
        return {
            subRegister: "",
            subTitle: "",
            subGrupe: "",
            subGrupeTitle: "",

            value: [],
            arrToSend: [],
            // values: [],
            sortDesc: false,
            fields: [
                { label: 'Област', key: 'l2', sortable: true },
                { label: 'Група', key: 'l3', sortable: true },
                { label: 'Врста документа', key: 'docType', sortable: true },
                { label: 'Назив', key: 'title', sortable: true },


            ],
            areaLevel1: 458,
            areaLevel2: -1,
            areaLevel3: -1,
            areaLevel4: -1,
            areaLevel5: -1,

            form: {
                docTypeIds: [],
                titleQuery: null,
                titleMustOccur: true,
                bodyQuery: null,
                bodyMustOccur: true,
                resultLimit: 50,
            },

            areaLevel_2_options: [],
            areaLevel_3_options: [],
            areaLevel_4_options: [],
            areaLevel_5_options: [],
            docTypes: [],
            docTypesLaws: [],
            authorities: [],
            resultLimitOptions: [50, 100, 200, 300, 400, 500],

            // Table data
            values: [],
            columns: [
                {
                    label: "Област",
                    name: "l2",
                    sortable: true,
                },
                {
                    label: "Група",
                    name: "l3",
                    sortable: true,
                },
                {
                    label: "Врста документа",
                    name: "docType",
                    sortable: true,
                    row_text_alignment: "text-left",
                },
                {
                    label: "Назив",
                    name: "title",
                    sortable: true,
                    slot_name: "title_link",
                    row_text_alignment: "text-left",
                    column_classes: "td-link"

                }
            ],


            searchResult: null,

            searchFilter: {
                docTypes: [],
                areas: [],
                authorities: [],
            },
            // axios
            baseDIApiUrl: window.env.VUE_APP_API_DI_DEV,
            baseREGApiUrl: window.env.VUE_APP_API_REG_DEV,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },

        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    computed: {
        userInfoState() {

            return store.userInfoState;
        }
    },
    components: {
        RegBaseHeaderSec,
        // SortedTable,
        // SortLink,
        ResultCounter
    },
    methods: {
        // buildLink(uuid) {
        //     axios.get(this.baseApiUrl + 'api/reg/meta/byActUuid/' + uuid)
        //         .then(response => {
        //             if (response.data.url !== undefined) {
        //                 // this.$router.push(response.data.url + '?q=' + uuid);
        //                 window.open(this.baseUrl + response.data.url.substr(1) + '/reg', '_blank');
        //             } else {
        //                 // this.$router.push('/reg/viewAct/' + uuid + '?q=' + uuid);
        //                 window.open(this.baseUrl + 'reg/viewAct/' + uuid + '?q=' + uuid, '_blank');
        //             }
        //         })
        // },
        onSubmit(evt) {
            evt.preventDefault();
            this.search();
        },
        search() {
            axios.post(this.baseDIApiUrl + 'REG/advancedSearch', this.getData()).then(response => {
                this.searchResult = response.data;
                this.values = response.data.result;
                // console.log("values : ", this.values);
            }).catch(function (error) {
                console.log(error);
            });
        },
        onReset(evt) {
            evt.preventDefault();
            // Reset our form values
            this.areaLevel1 = -1;
            this.areaLevel2 = -1;
            this.areaLevel3 = -1;
            this.areaLevel4 = -1;
            this.areaLevel5 = -1;
            this.form.docTypeIds = [];
            this.form.titleQuery = null;
            this.form.bodyQuery = null;
            this.form.titleMustOccur = true;
            this.form.bodyMustOccur = true;
            this.form.resultLimit = 50;
            this.searchResult = null;
        },
        fetchFilterData() {
            axios.get(this.baseREGApiUrl + 'standardSearch/filter').then(response => {
                // console.log(response);

                this.searchFilter = response.data;
                this.docTypes = response.data.docTypes;
            });
        },
        fetchFilterData_2() {
            axios.get(this.baseREGApiUrl + 'regAreas?parentId=' + this.areaLevel1)
                .then(response => {
                    this.areaLevel_2_options = response.data;
                    // console.log("tt" , this.areaLevel_2_options);
                })

        },
        exportWord() {
            var data = this.getData();
            data.append = '<table style="width: 100%;"><tr><td>Критеријуми претраге:</td></tr><tr><td>Подрегистар: ' + this.subRegister + '</td></tr><tr><td>Област: ' + this.subTitle + ' </td></tr><tr><td>Група: ' + this.subGrupe + ' </td></tr><tr><td>Подгрупа: ' + this.subGrupeTitle + '</td></tr><tr><td>Назив прописа - Све</td></tr>               <tr><td>Речи садржане у наслову: ' + this.form.titleQuery + '  </td></tr>                <tr><td>Речи садржане у тексту: ' + this.form.bodyQuery + '  </td></tr>                    </table>';

            axios.post(this.baseDIApiUrl + 'REG/export/advancedSearch', data, { responseType: 'blob' })
                .then(response => {
                    let a = document.createElement('a');
                    a.href = window.URL.createObjectURL(response.data);
                    a.download = "RezultatiPretrage.docx";
                    a.click();
                })
        },
        getData() {
            let dids = [];
            this.form.docTypeIds.filter(obj => {
                dids.push(obj.k);
            });
            var data = {
                l: [
                    this.areaLevel1,
                    this.areaLevel2,
                    this.areaLevel3,
                    this.areaLevel4,
                    -1,
                ],
                pau: (this.areaLevel5 == -1) ? null : this.areaLevel5,
                aids: [],
                dids: dids,
                tmo: this.form.titleMustOccur,
                bmo: this.form.bodyMustOccur,
                limit: this.form.resultLimit,
            };

            if (this.form.titleQuery !== null) {
                data.tk = this.form.titleQuery;
            }

            if (this.form.bodyQuery !== null) {
                data.bk = this.form.bodyQuery;
            }
            console.log("DATAA", data);
            return data;
        },
        keyV(event) {
            this.subRegister = event.target.selectedOptions[0].text;
            console.log(this.subRegister);
        },
        keyV1(event) {
            this.subTitle = event.target.selectedOptions[0].text;
            console.log(this.subTitle);
        },
        keyV2(event) {
            this.subGrupe = event.target.selectedOptions[0].text;
            console.log(this.subGrupe);
        },
        keyV3(event) {
            this.subGrupeTitle = event.target.selectedOptions[0].text;
            console.log(this.subGrupeTitle);
        },
    },
    watch: {
        areaLevel1: function () {
            this.areaLevel_2_options = [];
            this.areaLevel2 = -1;

            if (this.areaLevel1 != -1) {
                axios.get(this.baseREGApiUrl + 'regAreas?parentId=' + this.areaLevel1)
                    .then(response => {
                        this.areaLevel_2_options = response.data;
                    })
            }
        },

        areaLevel2: function () {
            this.areaLevel_3_options = [];
            this.areaLevel3 = -1;

            if (this.areaLevel2 != -1) {
                axios.get(this.baseREGApiUrl + 'regAreas?parentId=' + this.areaLevel2)
                    .then(response => {
                        this.areaLevel_3_options = response.data;
                    })
            }
        },
        areaLevel3: function () {
            this.areaLevel_5_options = [];
            this.areaLevel5 = -1;

            if (this.areaLevel3 != -1) {
                axios.get(this.baseREGApiUrl + 'regAreas?parentId=' + this.areaLevel3)
                    .then(response => {
                        this.areaLevel_4_options = response.data;
                    })
                axios.get(this.baseREGApiUrl + 'lawsAndSubareas/' + this.areaLevel3)
                    .then(response => {
                        this.areaLevel_5_options = response.data;
                    })
            }
        },
        areaLevel4: function () {
            this.areaLevel_5_options = [];
            this.areaLevel5 = -1;

            if (this.areaLevel4 != -1) {
                axios.get(this.baseREGApiUrl + 'lawsAndSubareas/' + this.areaLevel4)
                    .then(response => {
                        this.areaLevel_5_options = response.data;
                    })
            }
        }
    },
    mounted() {
        if (this.$route.query.q) {
            this.form.titleQuery = this.$route.query.q;
            this.search();
        }
        this.fetchFilterData();
        this.fetchFilterData_2();
    },
    beforeCreate: function () {
        document.body.className = 'color_reg';
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.table-bootstrap-vue thead tr th:nth-child(1) {
    width: 25%;
}

.table-bootstrap-vue thead tr th:nth-child(2) {
    width: 20%;
}

.table-bootstrap-vue thead tr th:nth-child(3) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(4) {
    width: 40%;
}

.register .multiselect__tag {
    background: #5dbb49;
    /* background: red;  */
    margin-top: 4px;
}

.register .multiselect__placeholder {
    color: black !important;
    font-size: 0.9rem;
}

.register .multiselect__select:before {
    border-color: black transparent transparent !important;
    border-width: 6px 3px 0 !important;
    opacity: 0.8;
}

.register .multiselect__tags {
    border-radius: unset !important;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.22);
    padding: 4px 40px 0 12px !important;
    border: 1px solid #ced4da;

}

.register .multiselect {
    min-height: 35px;
}

.multiselect__select {
    top: 4px !important;
    right: -9px !important;
}

#__BVID__116 {
    margin-top: -2px;
}

.register .multiselect__option--highlight {
    background: #5dbb49;
}
</style>
